
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'RIFLEGrade',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/RIFLEGrade.vue